import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = data => api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = data => api.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = data => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = data => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
// Login Method
export const postJwtLogin = data => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = data => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => api.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = (date) => api.get(url.GET_EVENTS, {month:date.month, year: date.year});

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = event => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => api.update(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event => api.delete(url.DELETE_EVENT+'/'+event.id);

// delete REPEAT Event
export const deleteRepeatEvents = event => api.create(url.DELETE_REPEAT_EVENTS, event);

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = params => api.get(`${url.GET_MESSAGES}/${params.roomId}`, { type: params.roomType });

// add Message
export const addMessage = message => api.create(url.ADD_MESSAGE, message);

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = forId => api.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = product => api.delete(url.DELETE_PRODUCT + '/' + product);

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = order => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = order => api.update(url.UPDATE_ORDER + '/' + order._id, order);

// delete Order
export const deleteOrder = order => api.delete(url.DELETE_ORDER + '/' + order);

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = customer => api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = customer => api.update(url.UPDATE_CUSTOMER + '/' + customer._id, customer);

// delete Customers
export const deleteCustomer = customer => api.delete(url.DELETE_CUSTOMER + '/' + customer);

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = task => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = task => api.update(url.UPDATE_TASK + '/' + task._id, task);

// delete Task
export const deleteTask = task => api.delete(url.DELETE_TASK + '/' + task);

// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = contact => api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = contact => api.update(url.UPDATE_CONTACT + '/' + contact._id, contact);

// delete Contact
export const deleteContact = contact => api.delete(url.DELETE_CONTACT + '/' + contact);

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = company => api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = company => api.update(url.UPDATE_COMPANIES + '/' + company.id, company);

// delete Companies
export const deleteCompanies = company => api.delete(url.DELETE_COMPANIES + '/' + company);

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = lead => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = lead => api.update(url.UPDATE_LEAD + '/' + lead._id, lead);

// delete Lead
export const deleteLead = lead => api.delete(url.DELETE_LEAD + '/' + lead);

// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = invoice => api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = invoice => api.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = invoice => api.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = ticket => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = ticket => api.update(url.UPDATE_TICKET + '/' + ticket._id, ticket);

// delete Tickets 
export const deleteTicket = ticket => api.delete(url.DELETE_TICKET + '/' + ticket);

//Machine
export const getMachineList = () => api.get(url.GET_MACHINE_LIST);

export const addNewMachine = machine => api.create(url.ADD_NEW_MACHINE, machine);

export const updateMachine = machine => api.update(url.UPDATE_MACHINE, machine);

export const deleteMachine = machine => api.delete(url.DELETE_MACHINE+ '/' + machine);

//Machine Category
export const getMachineCategoryList = () => api.get(url.GET_MACHINE_CATEGORY_LIST);

export const addNewMachineCategory = machine => api.create(url.ADD_NEW_MACHINE_CATEGORY, machine);

export const updateMachineCategory = machine => api.update(url.UPDATE_MACHINE_CATEGORY, machine);

export const deleteMachineCategory = machine => api.delete(url.DELETE_MACHINE_CATEGORY+ '/' + machine);

//Machine Type
export const getMachineTypeList = () => api.get(url.GET_MACHINE_TYPE_LIST);

export const addNewMachineType = machine => api.create(url.ADD_NEW_MACHINE_TYPE, machine);

export const updateMachineType = machine => api.update(url.UPDATE_MACHINE_TYPE, machine);

export const deleteMachineType = machine => api.delete(url.DELETE_MACHINE_TYPE+ '/' + machine);

//Library
export const getFoldersMap = () => api.get(url.GET_FOLDERS_MAP);

export const addNewFolder = data => api.create(url.ADD_NEW_FOLDER, data);

export const uploadFilesToLibrary = data => api.create(url.UPLOAD_FILES, data);

export const deleteFilesFromLibrary = data => api.delete(url.DELETE_FILES+'/'+data);

export const moveFiles = data => api.update(url.MOVE_FILES, data);

//Timekeeping
export const getTimekeepingList = (params) => api.get(url.GET_TIMEKEEPING_LIST,params);

//User
export const getUserList = () => api.get(url.GET_USER_LIST);
export const addNewUser = data => api.create(url.ADD_NEW_USER, data);
export const updateUser = data => api.update(url.UPDATE_USER, data);
export const deleteUser = data => api.delete(url.DELETE_USER+ '/' + data);
export const getAllUsers = () => api.get(url.GET_ALL_USERS);

//Role
export const getRoleList = () => api.get(url.GET_ROLE_LIST);
export const addNewRole = data => api.create(url.ADD_NEW_ROLE, data);
export const updateRole = data => api.update(url.UPDATE_ROLE, data);
export const deleteRole = data => api.delete(url.DELETE_ROLE+ '/' + data);

//Config
export const getConfig = () => api.get(url.GET_ALL_CONFIGURATION);

export const updateConfig = data => api.update(url.UPDATE_CONFIG, data);


export const getAllEquipments = () => api.get(url.GET_ALL_EQUIPMENTS);

export const deleteFile = data => api.create(url.DELETE_FILE, data);

export const getNotificationList = () => api.get(url.GET_NOTIFICATION_LIST);

//Company
export const getCompany = () => api.get(url.GET_COMPANIES);

export const addNewCompany = company => api.create(url.ADD_NEW_COMPANIES, company);

export const updateCompany = company => api.update(url.UPDATE_COMPANIES + '/' + company.id, company);

export const deleteCompany = company => api.delete(url.DELETE_COMPANIES + '/' + company);

export const getMessagesList = () => api.get(url.GET_MESSAGES_LIST);